import React, { PureComponent } from "react";
import { withTranslation } from "react-i18next";
import { Dialog, withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import styles from "./PaymentMethodDialog.module.scss";
import Button from "@material-ui/core/Button";
import UpperCaseText from "../../utils/UpperCaseText";

class PaymentMethodDialog extends PureComponent {
  render() {
    const StyledDialog = withStyles({
      paper: {
        width: 500,
      },
    })(Dialog);

    return (
      <StyledDialog open={this.props.open}>
        <Grid container className={styles.dialog}>
          <Grid item xs={12}>
            <div className={styles.header}>
              {this.props.t("CustomerOrderDetails.switchPayment")}
              <span>{UpperCaseText(this.props.paymentType)}</span>
            </div>
            <div className={styles.subheader}>
              {this.props.t("CustomerOrderDetails.confirmSwitch")}
            </div>
          </Grid>
          <Grid item md={12}>
            <div className={styles.dialogActions}>
              <Button
                data-testid="cancelDialog"
                className="cancelledButton dialog"
                onClick={this.props.closeDialog}
              >
                {this.props.t("CustomerOrderDetails.cancel")}
              </Button>
              <Button
                data-testid="confirmDialog"
                className="confirmButton dialog"
                onClick={this.props.confirmDialog}
              >
                {this.props.t("CustomerOrderDetails.confirm")}
              </Button>
            </div>
          </Grid>
        </Grid>
      </StyledDialog>
    );
  }
}

export default withTranslation("emp")(PaymentMethodDialog);
